import axiosInstance from '@/service/helpers/axios'
export async function getMyUserPermission() {
  const result = await axiosInstance.get('/user-permission/self/permission')
  return result
}
